/* Wengberg · "Gem som billede" – tegner et 1080×1920 produktbillede i browseren. */
(function () {
  if (window.__wgGemBillede) return;
  window.__wgGemBillede = true;

  var W = 1080, H = 1920, PAD = 72;
  var C = { ink: '#232323', muted: '#6b6b6b', line: '#e8e8e8', soft: '#f5f4f1', green: '#43b14e', sale: '#d0342c' };
  var QR_LIB = 'https://cdnjs.cloudflare.com/ajax/libs/qrcode-generator/1.4.4/qrcode.min.js';

  function kr(cents) {
    return new Intl.NumberFormat('da-DK', { maximumFractionDigits: 0 }).format(Math.round(cents / 100)) + ' kr.';
  }

  function cm(v) {
    if (v === null || v === undefined || v === '') return '';
    v = String(v).trim();
    return /cm$/i.test(v) ? v : v + ' cm';
  }

  function loadImage(src) {
    return new Promise(function (resolve) {
      if (!src) return resolve(null);
      var img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = function () { resolve(img); };
      img.onerror = function () { resolve(null); };
      img.src = src.indexOf('//') === 0 ? location.protocol + src : src;
    });
  }

  var qrPromise;
  function loadQrLib() {
    if (window.qrcode) return Promise.resolve(window.qrcode);
    if (!qrPromise) {
      qrPromise = new Promise(function (resolve) {
        var s = document.createElement('script');
        s.src = QR_LIB;
        s.onload = function () { resolve(window.qrcode || null); };
        s.onerror = function () { resolve(null); };
        document.head.appendChild(s);
      });
    }
    return qrPromise;
  }

  function currentVariant(data) {
    var id = null;
    var input = document.querySelector('#product-form-' + data.productId + ' [name="id"]');
    if (input && input.value) id = Number(input.value);
    if (!id) {
      var p = new URLSearchParams(location.search).get('variant');
      if (p) id = Number(p);
    }
    if (!id) id = data.selectedVariantId;
    for (var i = 0; i < data.variants.length; i++) if (data.variants[i].id === id) return data.variants[i];
    return data.variants[0];
  }

  function roundRect(ctx, x, y, w, h, r) {
    ctx.beginPath();
    ctx.moveTo(x + r, y);
    ctx.arcTo(x + w, y, x + w, y + h, r);
    ctx.arcTo(x + w, y + h, x, y + h, r);
    ctx.arcTo(x, y + h, x, y, r);
    ctx.arcTo(x, y, x + w, y, r);
    ctx.closePath();
  }

  // Ombryder tekst til max antal linjer; sidste linje afkortes med "…".
  function wrap(ctx, text, maxW, maxLines) {
    var words = String(text).split(/\s+/), lines = [], line = '';
    for (var i = 0; i < words.length; i++) {
      var test = line ? line + ' ' + words[i] : words[i];
      if (ctx.measureText(test).width > maxW && line) {
        lines.push(line);
        line = words[i];
      } else {
        line = test;
      }
    }
    if (line) lines.push(line);
    if (lines.length > maxLines) {
      lines = lines.slice(0, maxLines);
      var last = lines[maxLines - 1];
      while (last && ctx.measureText(last + '…').width > maxW) last = last.slice(0, -1);
      lines[maxLines - 1] = last.replace(/\s+$/, '') + '…';
    }
    return lines;
  }

  function drawContain(ctx, img, x, y, w, h) {
    var s = Math.min(w / img.naturalWidth, h / img.naturalHeight);
    var dw = img.naturalWidth * s, dh = img.naturalHeight * s;
    ctx.drawImage(img, x + (w - dw) / 2, y + (h - dh) / 2, dw, dh);
  }

  function render(data, variant, imgs, qrLib, font) {
    var cv = document.createElement('canvas');
    cv.width = W;
    cv.height = H;
    var ctx = cv.getContext('2d');
    var f = function (weight, size) { return weight + ' ' + size + 'px ' + font; };
    ctx.textBaseline = 'alphabetic';

    ctx.fillStyle = '#ffffff';
    ctx.fillRect(0, 0, W, H);

    // Logo
    var y = 64;
    if (imgs.logo) {
      var lh = 96, lw = Math.min(W - 2 * PAD, imgs.logo.naturalWidth * lh / imgs.logo.naturalHeight);
      lh = lw * imgs.logo.naturalHeight / imgs.logo.naturalWidth;
      ctx.drawImage(imgs.logo, (W - lw) / 2, y, lw, lh);
    } else {
      ctx.fillStyle = C.ink;
      ctx.font = f(800, 44);
      ctx.textAlign = 'center';
      ctx.fillText(data.shopName || 'wengberg.dk', W / 2, y + 64);
      ctx.textAlign = 'left';
    }

    // Produktbillede
    var bx = PAD, by = 200, bw = W - 2 * PAD, bh = 700;
    ctx.save();
    roundRect(ctx, bx, by, bw, bh, 28);
    ctx.fillStyle = C.soft;
    ctx.fill();
    ctx.clip();
    if (imgs.product) {
      ctx.fillStyle = '#ffffff';
      ctx.fillRect(bx, by, bw, bh);
      drawContain(ctx, imgs.product, bx + 8, by + 8, bw - 16, bh - 16);
    }
    ctx.restore();

    // Tilbudsmærkat
    var onSale = variant.compare > variant.price;
    if (onSale) {
      var pct = Math.round((1 - variant.price / variant.compare) * 100);
      var tag = 'TILBUD  −' + pct + '%';
      ctx.font = f(800, 32);
      var tw = ctx.measureText(tag).width + 48;
      roundRect(ctx, bx + 28, by + 28, tw, 64, 32);
      ctx.fillStyle = C.sale;
      ctx.fill();
      ctx.fillStyle = '#ffffff';
      ctx.fillText(tag, bx + 52, by + 72);
    }

    // Brand + titel
    y = by + bh + 76;
    if (data.brand) {
      ctx.fillStyle = C.muted;
      ctx.font = f(700, 28);
      ctx.fillText(String(data.brand).toUpperCase(), PAD, y);
      y += 62;
    } else {
      y += 20;
    }
    ctx.fillStyle = C.ink;
    ctx.font = f(800, 56);
    wrap(ctx, data.title, W - 2 * PAD, 2).forEach(function (l) {
      ctx.fillText(l, PAD, y);
      y += 66;
    });

    // Valgte varianter
    var opts = [];
    (data.optionNames || []).forEach(function (name, i) {
      var v = variant.options[i];
      if (v && v !== 'Default Title') opts.push(name + ': ' + v);
    });
    if (opts.length) {
      ctx.font = f(400, 32);
      ctx.fillStyle = C.muted;
      y += 4;
      opts.slice(0, 3).forEach(function (o) {
        wrap(ctx, o, W - 2 * PAD, 1).forEach(function (l) {
          ctx.fillText(l, PAD, y);
          y += 46;
        });
      });
    }

    // Pris
    y += 54;
    ctx.fillStyle = onSale ? C.sale : C.ink;
    ctx.font = f(800, 84);
    var priceText = kr(variant.price);
    ctx.fillText(priceText, PAD, y);
    if (onSale) {
      var px = PAD + ctx.measureText(priceText).width + 28;
      ctx.font = f(400, 40);
      ctx.fillStyle = C.muted;
      var old = 'Før ' + kr(variant.compare);
      ctx.fillText(old, px, y - 4);
      var ow = ctx.measureText(old).width;
      ctx.fillRect(px + ctx.measureText('Før ').width, y - 18, ow - ctx.measureText('Før ').width, 3);
      y += 56;
      ctx.font = f(700, 32);
      ctx.fillStyle = C.green;
      ctx.fillText('Du sparer ' + kr(variant.compare - variant.price), PAD, y);
    }

    // Specifikationer
    var s = data.specs || {};
    var rows = [];
    var dims = [s.width, s.length, s.height].filter(function (v) { return v !== null && v !== undefined && v !== ''; });
    if (dims.length) rows.push(['Mål (B×D×H)', dims.map(function (v) { return String(v).replace(/\s*cm$/i, ''); }).join(' × ') + ' cm']);
    if (s.seatHeight) rows.push(['Sædehøjde', cm(s.seatHeight)]);
    if (s.seatDepth) rows.push(['Sædedybde', cm(s.seatDepth)]);
    if (s.delivery) rows.push(['Leveringstid', String(s.delivery)]);
    if (s.material) rows.push(['Materiale', String(s.material)]);

    var footerTop = H - 250;
    y += 40;
    var rowH = 60;
    var maxRows = Math.max(0, Math.floor((footerTop - 30 - y) / rowH));
    rows.slice(0, maxRows).forEach(function (r) {
      ctx.fillStyle = C.line;
      ctx.fillRect(PAD, y, W - 2 * PAD, 2);
      ctx.font = f(600, 30);
      ctx.fillStyle = C.muted;
      ctx.fillText(r[0], PAD, y + 41);
      ctx.font = f(600, 30);
      ctx.fillStyle = C.ink;
      ctx.textAlign = 'right';
      var val = wrap(ctx, r[1], W - 2 * PAD - 330, 1)[0];
      ctx.fillText(val, W - PAD, y + 41);
      ctx.textAlign = 'left';
      y += rowH;
    });

    // Bund: QR + link
    ctx.fillStyle = C.soft;
    ctx.fillRect(0, footerTop, W, H - footerTop);
    var qrSize = 170, qx = PAD, qy = footerTop + 40;
    var textX = PAD;
    if (qrLib) {
      try {
        var qr = qrLib(0, 'M');
        qr.addData(data.url + '?variant=' + variant.id);
        qr.make();
        var n = qr.getModuleCount(), cell = qrSize / (n + 2);
        ctx.fillStyle = '#ffffff';
        ctx.fillRect(qx, qy, qrSize, qrSize);
        ctx.fillStyle = C.ink;
        for (var r = 0; r < n; r++) for (var c = 0; c < n; c++) {
          if (qr.isDark(r, c)) ctx.fillRect(qx + (c + 1) * cell, qy + (r + 1) * cell, Math.ceil(cell), Math.ceil(cell));
        }
        textX = qx + qrSize + 40;
      } catch (e) { /* uden QR */ }
    }
    ctx.fillStyle = C.ink;
    ctx.font = f(800, 38);
    ctx.fillText('Se produktet på', textX, qy + 62);
    ctx.fillStyle = C.green;
    ctx.fillText(location.hostname.replace(/^www\./, ''), textX, qy + 112);
    ctx.fillStyle = C.muted;
    ctx.font = f(400, 24);
    var d = new Date();
    ctx.fillText('Pris pr. ' + d.toLocaleDateString('da-DK') + '. Der tages forbehold for fejl.', textX, qy + 158);

    return cv;
  }

  function slug(t) {
    return String(t).toLowerCase().replace(/æ/g, 'ae').replace(/ø/g, 'oe').replace(/å/g, 'aa')
      .replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 60) || 'produkt';
  }

  function showOverlay(blob, filename, title) {
    var url = URL.createObjectURL(blob);
    var file = null;
    try { file = new File([blob], filename, { type: 'image/png' }); } catch (e) {}
    var canShare = !!(file && navigator.canShare && navigator.canShare({ files: [file] }));

    var ov = document.createElement('div');
    ov.className = 'wg-gem-overlay';
    ov.setAttribute('role', 'dialog');
    ov.setAttribute('aria-modal', 'true');
    ov.setAttribute('aria-label', 'Gem som billede');
    ov.innerHTML =
      '<div class="wg-gem-overlay__box">' +
        '<img class="wg-gem-overlay__img" alt="">' +
        '<p class="wg-gem-overlay__hint">' + (canShare ? 'Tryk “Gem / del” og vælg “Gem billede”.' : 'Billedet er klar til at blive hentet.') + '</p>' +
        '<div class="wg-gem-overlay__actions">' +
          (canShare ? '<button type="button" class="wg-gem-overlay__primary" data-share>Gem / del</button>' : '') +
          '<a class="' + (canShare ? 'wg-gem-overlay__secondary' : 'wg-gem-overlay__primary') + '" data-dl>Download</a>' +
          '<button type="button" class="wg-gem-overlay__secondary" data-close>Luk</button>' +
        '</div>' +
      '</div>';
    var img = ov.querySelector('img');
    img.src = url;
    img.alt = title;
    var dl = ov.querySelector('[data-dl]');
    dl.href = url;
    dl.download = filename;

    function close() {
      ov.remove();
      document.removeEventListener('keydown', onKey);
      setTimeout(function () { URL.revokeObjectURL(url); }, 1000);
    }
    function onKey(e) { if (e.key === 'Escape') close(); }
    ov.addEventListener('click', function (e) { if (e.target === ov) close(); });
    ov.querySelector('[data-close]').addEventListener('click', close);
    document.addEventListener('keydown', onKey);
    var sh = ov.querySelector('[data-share]');
    if (sh) sh.addEventListener('click', function () {
      navigator.share({ files: [file], title: title }).catch(function () {});
    });
    document.body.appendChild(ov);
    (sh || dl).focus();
  }

  function onClick(btn) {
    var root = btn.closest('[data-wg-gem-billede]');
    var data;
    try { data = JSON.parse(root.querySelector('[data-wg-gem-data]').textContent); } catch (e) { return; }
    var label = root.querySelector('[data-wg-gem-label]');
    var orig = label.textContent;
    btn.disabled = true;
    label.textContent = 'Laver billede…';

    var variant = currentVariant(data);
    var font = getComputedStyle(document.body).fontFamily || 'sans-serif';
    var fontsReady = document.fonts && document.fonts.ready ? document.fonts.ready : Promise.resolve();

    Promise.all([
      loadImage(variant.image || data.fallbackImage),
      loadImage(data.logo),
      loadQrLib(),
      fontsReady
    ]).then(function (res) {
      var cv = render(data, variant, { product: res[0], logo: res[1] }, res[2], font);
      return new Promise(function (resolve, reject) {
        try { cv.toBlob(function (b) { b ? resolve(b) : reject(new Error('blob')); }, 'image/png'); }
        catch (e) { reject(e); }
      });
    }).then(function (blob) {
      showOverlay(blob, 'wengberg-' + slug(data.title) + '.png', data.title);
    }).catch(function () {
      alert('Billedet kunne ikke laves. Prøv igen om lidt.');
    }).then(function () {
      btn.disabled = false;
      label.textContent = orig;
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-wg-gem-btn]');
    if (btn) onClick(btn);
  });
})();
